<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_7382_36358)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM0 12C2.89694e-07 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 -2.89694e-07 12 0C5.37258 2.89694e-07 -2.89694e-07 5.37258 0 12Z"
    />
    <path
      d="M10.2426 17L11.6569 15.5858L11.6464 15.5754L18.7071 8.51472L17.2929 7.1005L10.2322 14.1612L7.41421 11.3431L6 12.7574L8.81802 15.5754L8.80761 15.5858L10.2218 17L10.2322 16.9896L10.2426 17Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_7382_36358">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>
